

































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { BarchCreateHouseInfo } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import Rules from '@/utils/rules'
import Conf from '@/config/config'
import API from '@/api/api'
import { getUser } from '@/store/userStore'
import router from '@/router'
import { VTable, TableHander } from '@/components/table'

@Component({
  components: {
    VTable,
  },
})
export default class ImportHouseDialog extends Vue {
  @Emit('close')
  private close() {
    this.show = false
  }

  private show = false
  private data = {
    importData: [],
    importErrorMsgs: [],
  }
  private fileUploadUrl = Conf.API_HOST + API.importGoodsData
  private headers = { Authorization: '' }
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '业主姓名', param: 'reservedName' },
    { title: '预留手机号', param: 'reservedMobilePhone' },
    { title: '身份证', param: 'reservedIdCard' },
    { title: '面积', param: 'reservedArea' },
    { title: '小区名称', param: 'communityName' },
    { title: '小区地址', param: 'communityAddress' },
    { title: '户号', param: 'houseAccount' },
  ]

  private created() {
    this.headers.Authorization = getUser().token || ''
  }

  public uploadSuccess(response: any) {
    const { data, code, msg } = response
    if (code == 1300004) {
      // 未登录
      Message.error(msg)
      router.push('/login')
      return
    } else if (code != 10000) {
      // 异常
      console.log('sas')
      Message.error(msg)
      return
    }

    this.data = data
  }
  public open() {
    this.show = true
    this.data = { importData: [], importErrorMsgs: [] }
  }

  public async save() {
    console.log('保存')
    const { importData, importErrorMsgs } = this.data
    if (importErrorMsgs.length > 0) {
      Message.error('文档存在错误信息，请先调整')
      return
    }
    if (importData.length <= 0) {
      Message.error('请先上传文档，并确保存在数据')
      return
    }
    const result = await BarchCreateHouseInfo({ batchHouseInfoAos: importData })

    this.close()
 }
}
